/**
 * What an API refusal says to the person who caused it.
 *
 * The server answers a refusal with a problem document: an English title for whoever reads the
 * wire, and a `type` URI whose last segment names the refusal — "premium-video-limit",
 * "no-credits". The title is not for the owner: "This post has already had its clip." on a
 * Macedonian screen is the platform speaking a language it was told never to. The type is what
 * gets translated; the title is the fallback for a refusal nobody has given words to yet.
 */
export function problemText(t, error) {
  const slug = typeof error?.type === 'string' ? error.type.split('/errors/')[1] : null

  if (!slug) return error?.message

  return t(`errors.${slug}`, { defaultValue: error.message })
}
